const MFE_ENV = {
  REACT_APP_MFE_PREFIX: process.env["REACT_APP_MFE_PREFIX"] || "apl",
  REACT_APP_MFE_MODULE: process.env["REACT_APP_MFE_MODULE"] || "/appLocal",
  REACT_APP_MFE_ROUTE: process.env["REACT_APP_MFE_ROUTE"] || "/app-local",
  REACT_APP_MFE_PORT: process.env["REACT_APP_MFE_PORT"] || "3005",
};

export const MFE = [
  {
    name: "App Local",
    icon: "DollarSignCircleIcon",
    external_link: "",
    active: true,
    application: {
      app_prefix: MFE_ENV.REACT_APP_MFE_PREFIX,
      module_name: MFE_ENV.REACT_APP_MFE_MODULE,
      route_prefix: MFE_ENV.REACT_APP_MFE_ROUTE,
      host: `http://localhost:${MFE_ENV.REACT_APP_MFE_PORT}/remoteEntry.js`,
      active: true,
    },
  },
];
